import { render } from "./TeamListCardLayout.vue?vue&type=template&id=224e098c&scoped=true"
import script from "./TeamListCardLayout.vue?vue&type=script&lang=js"
export * from "./TeamListCardLayout.vue?vue&type=script&lang=js"

import "./TeamListCardLayout.vue?vue&type=style&index=0&id=224e098c&lang=scss"
import "./TeamListCardLayout.vue?vue&type=style&index=1&id=224e098c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-224e098c"

export default script